import { apiClient } from './client';

export function getLocations (shopId: number | string) {
  return apiClient.get(`/${shopId}/locations`);
}

export function updateLocation (shopId: number | string, locationId: number | string, payload: Record<string, unknown>) {
  return apiClient.put(`/${shopId}/locations/${locationId}`, payload);
}

export function syncLocations (shopId: number | string) {
  return apiClient.get(`/${shopId}/locations/sync`);
}
